import { getDomain } from "../../utils/helpers.js";
import store from "@/store";
export function dateTimeCountdown(dataTime) {
  const currentTime = new Date().getTime();
  const distance = dataTime - currentTime;

  const absDistance = Math.abs(distance);
  const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((absDistance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

  const timeStr = `${days ? days + " days" : ""} ${
    hours ? hours + " hours" : ""
  }  ${minutes} minutes`;

  if (distance >= 0) {
    return `In ${timeStr}`;
  } else {
    return `Delay by ${timeStr}`;
  }
}

export function getETA(request) {
  const displayValue = request.dueByTimeDisplayValue;
  if (request.statusName == "Closed" || !displayValue) {
    return displayValue;
  }
  return `${dateTimeCountdown(request.dueByTimeValue)} / ${displayValue}`;
}

export async function loadFile(file) {
  const previewTab = window.open("", "_blank");
  if (!previewTab) return;
  previewTab.document.write("Loading attachment...");

  const url =
    getDomain() +
    `/api/manageengine/GetAttachments?url=${encodeURIComponent(
      file.content_url
    )}`;
  try {
    const response = await fetch(url, {
      headers: {
        authorization: `${$cookies.get("user-token")}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load attachment. Status: ${response.status}`);
    }

    const blob = await response.blob();
    const headerType = (response.headers.get("content-type") || "")
      .split(";")[0]
      .trim()
      .toLowerCase();
    const blobType = (blob.type || "").toLowerCase();
    const fileName = (file.name || "").toLowerCase();
    const ext = fileName.includes(".") ? fileName.split(".").pop() : "";
    const imageExts = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
    const isImage =
      headerType.startsWith("image/") ||
      blobType.startsWith("image/") ||
      imageExts.includes(ext);

    const objectUrl = URL.createObjectURL(blob);

    if (isImage) {
      previewTab.document.open();
      previewTab.document.write(`
          <html>
            <head><title>${file.name || "Attachment"}</title></head>
            <body style="margin:0;background:#111;display:flex;align-items:center;justify-content:center;min-height:100vh;">
              <img src="${objectUrl}" alt="attachment" style="max-width:100%;max-height:100vh;object-fit:contain;" />
            </body>
          </html>
        `);
      previewTab.document.close();
    } else {
      previewTab.location.href = objectUrl;
    }

    setTimeout(() => URL.revokeObjectURL(objectUrl), 2 * 60 * 1000);
  } catch (error) {
    previewTab.close();
    console.error("Failed to preview attachment", error);
  }
}

export function isTechnician() {
  const roles = store.getters["authentication/getRoles"];
  const isTech = roles.includes("Technician");
  return isTech;
}

export function isAdmin() {
  const isAdmin = store.getters["authentication/isAdmin"];
  if (!isAdmin || isAdmin == "false") return false;
  return true;
}

export function getStatusIcon(request) {
  if (!request || !request.statusName) return;
  return statusIcon(request.statusName);
}

export function statusIcon(value) {
  const options = {
    Closed: "mdi-check-circle",
    Open: "mdi-clock",
    Reopened: "mdi-clock",
    "On Hold": "mdi-clock",
    Canceled: "mdi-cancel",
  };
  return options[value] || "";
}

export function getStatusIconColor(request) {
  if (!request || !request.statusName) return;
  return statusIconColor(request.statusName);
}

export function statusIconColor(value) {
  const options = {
    Closed: "#2ecc71",
    Open: "#f1c40f",
    Reopened: "#f1c40f",
    "On Hold": "#3498db",
    Canceled: "#e74c3c",
  };
  return options[value] || "#bdc3c7";
}

export function getClosedInfo(request) {
  if (!request || !request.statusName) return;
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  if (!request.lastUpdatedTime) {
    return;
  }
  if (request.statusName != "Closed") {
    let lastUpdatedTime = new Date(request.lastUpdatedTime);
    return `Last updated on ${lastUpdatedTime.toLocaleDateString(
      "en-US",
      options
    )} at ${lastUpdatedTime.toLocaleTimeString()} `;
  }
  let completedTime = new Date(request.completedTime);

  const details = `
  Closed on ${completedTime.toLocaleDateString("en-US", options)}
  at ${completedTime.toLocaleTimeString()} <br />
  <style>
    .res-content { display: block !important; max-height: 80px; overflow-y: auto; overflow-x: hidden; word-break: break-word; white-space: normal; max-width: 500px; }
    .res-content div { display: block !important; }
  </style>`;
  const resolution = ` <b>Resolution:</b>
  <span class="res-content">${
    request.resolutionContent
      ? request.resolutionContent
          .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>")
          .replace(
            /(<div[^>]*>\s*(<br\s*\/?>)?\s*<\/div>\s*){2,}/gi,
            "<div></div>"
          )
      : "No resolution has been submitted for this ticket."
  }</span>`;
  if (request.resolutionContent) {
    return details + resolution;
  }
  return details;
}

export function isAudioFile(fileName) {
  const audioExtensions = [".mp3", ".wav", ".ogg", ".m4a"];
  return audioExtensions.some((ext) => fileName.toLowerCase().endsWith(ext));
}

export function getAudioSrc(file) {
  return `${getDomain()}/api/manageengine/GetAttachments?url=${
    file.content_url
  }&name=${file.name}`;
}

export function getTechnician(request) {
  if (!request || !request.technicianID)
    return "This ticket has not yet been assigned";

  return request.technicianName;
}

export const statusClosed = [
  "Closed",
  "Canceled",
  "Filter Decline",
  "Resolved",
];
export const statusOpen = ["Open", "Reopened"];

const loadingAttachment = `
    <html>
      <head>
        <title>Loading attachment...</title>
        <style>
          body {
            margin: 0;
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #0f172a, #1e293b);
            color: #f8fafc;
            font-family: "Segoe UI", Arial, sans-serif;
          }
          .loader {
            text-align: center;
          }
          .spinner {
            width: 54px;
            height: 54px;
            margin: 0 auto 14px;
            border: 5px solid rgba(255, 255, 255, 0.2);
            border-top-color: #38bdf8;
            border-radius: 50%;
            animation: spin 0.9s linear infinite;
          }
          .subtitle {
            font-size: 13px;
            opacity: 0.78;
            margin-top: 6px;
          }
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        </style>
      </head>
      <body>
        <div class="loader">
          <div class="spinner"></div>
          <div>Loading attachment...</div>
          <div class="subtitle">Preparing preview</div>
        </div>
      </body>
    </html>
  `;

/** http(s) in text nodes only; skips inside <a> (safe after rich paste). */
export function linkifyPlainUrlsInHtml(html) {
  const root = document.createElement("div");
  root.innerHTML = html;
  const re = /(https?:\/\/[^\s<]+)/g;
  function walk(n) {
    if (n.nodeType === 3) {
      const t = n.nodeValue;
      re.lastIndex = 0;
      if (!re.test(t)) return;
      re.lastIndex = 0;
      const fr = document.createDocumentFragment();
      let i = 0,
        m;
      while ((m = re.exec(t))) {
        if (m.index > i)
          fr.appendChild(document.createTextNode(t.slice(i, m.index)));
        const a = document.createElement("a");
        a.href = m[1];
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.appendChild(document.createTextNode(m[1]));
        fr.appendChild(a);
        i = m.index + m[1].length;
      }
      fr.appendChild(document.createTextNode(t.slice(i)));
      n.parentNode.replaceChild(fr, n);
      return;
    }
    if (n.nodeType === 1 && n.tagName !== "A") {
      [].slice.call(n.childNodes).forEach(walk);
    }
  }
  walk(root);
  return root.innerHTML;
}

export const priorityOptions = [
  {
    text: "High",
    name: "1 High",
    color: "#e74c3c",
    id: "24078000000006805",
  },
  {
    text: "High",
    name: "3 Option 8",
    color: "#e74c3c",
    id: "24078000000006803",
  },
  {
    text: "Normal",
    name: "2 Normal",
    color: "#f39c12",
    id: "24078000000006801",
  },
  {
    text: "Low",
    name: "4 Low",
    color: "#7f8c8d",
    id: "24078000000006799",
  },
];
